import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=b3510f84&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=ts&"
export * from "./ContactUs.vue?vue&type=script&lang=ts&"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=b3510f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3510f84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow})
